import {connect} from "react-redux";
import Home from "./Home"
import { getServices } from "../../redux/actions/newService/customerService.action";
import { setIncidentActiveTab } from "../../redux/actions/incidentManagement/incidentTab.action";
import { setServiceActiveTab } from "../../redux/actions/newService/service.actions";
import { getAllCustomerList } from "../../redux/actions/userManagement/getAllCustomerList.action";
import { getWidgetLayoutConfig } from "../../redux/actions/home/widgetLayout.actuion";
import { getFilteredCustomers } from "../../redux/actions/userManagement/filterCustomers.action";
import {getUserReport} from '../../redux/actions/home/userReport.action'

const mapStateToProps = (state) => {
    return {
        myRights : state.myRights.myRights,   
        broadCastnotification:state.notifications.broadcastNotification,
        filterCustomers:state.onboardingRequest.filterCustomers?.customers,
        customerLoading:state.onboardingRequest.filterCustomers.loading,
        widgetLayout:state.widLayoutConfig,
        customerData:state?.dashBoardCounts?.customerData?.data,
        // userReport:state.userReport
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getServices: ()=>{
            return dispatch(getServices())
        },
        getWidgetLayoutConfig:() => {
            return dispatch(getWidgetLayoutConfig());
        },
        getFilteredCustomers: () => {
            return dispatch(getFilteredCustomers())
        },
        // getUserReport: () => {
        //     return dispatch(getUserReport())
        // },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);